import { addDays } from 'utils/date-fns/index.js';
import { ISODateString } from 'utils/toUTCStrings.js';

const EXCEL_EPOCH = new Date('1899-12-30');

function stringToDate(value) {
  const parts = value.split(/\D+/);
  const ymdString = parts.reverse().join('-');
  const result = new Date(ymdString);
  result.setHours(0);
  return result;
}

function formatDate(value) {
  switch (typeof value) {
    case 'number':
      return addDays(EXCEL_EPOCH, value);
    case 'string':
      return stringToDate(value);
    default:
      if (value instanceof Date) {
        return value;
      }
      throw new Error(`Invalid date value: ${value}`);
  }
}

function mapRow(row, map) {
  const result = {};
  Object.keys(map).forEach((key) => {
    const val = row[map[key]];
    result[key] = key === 'birthDate' ? ISODateString(formatDate(val)) : val;
  });
  return result;
}

function mapData(data, map) {
  return data.rows.map((row) => mapRow(row, map));
}

export default mapData;
